module.exports = __webpack_public_path__ + "static/media/ttc-logo-icon.ae9bc1d1.svg";